module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAC0CAYAAABVEkZPAAAAGklEQVQokWP4////fyYGBgaGUWKUGCUGggAAcboFYxapwgEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/gang.png
// module id = FAnc
// module chunks = 0